import { render, staticRenderFns } from "./Riches.vue?vue&type=template&id=f0b8ee2e&scoped=true&"
import script from "./Riches.vue?vue&type=script&lang=js&"
export * from "./Riches.vue?vue&type=script&lang=js&"
import style0 from "./Riches.vue?vue&type=style&index=0&id=f0b8ee2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b8ee2e",
  null
  
)

export default component.exports